import { render, staticRenderFns } from "./newOrder.vue?vue&type=template&id=14533434&scoped=true&"
import script from "./newOrder.vue?vue&type=script&lang=ts&"
export * from "./newOrder.vue?vue&type=script&lang=ts&"
import style0 from "./newOrder.vue?vue&type=style&index=0&id=14533434&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14533434",
  null
  
)

export default component.exports